<template>
    <div class="tebex-footer-wrapper" :class="$store.state.app.store.darkMode ? 'tebex-footer-wrapper-dark': ''">
        <div class="tebex-footer-container d-flex align-items-center">

            <div class="tebex-footer-image">
                <a href="https://www.tebex.io" target="_blank">
                    <img :src="$store.state.app.store.darkMode ? '/img/tebex-dark-new.png' : '/img/tebex-new.png'" alt="Tebex logo" width="54px">
                </a>
            </div>

            <span class="mb-0 tebex-footer-text">This website and its checkout process is owned &amp; operated by Tebex Limited, who handle product fulfilment, billing support and refunds.</span>
            <div class="ml-auto tebex-footer-links">
                <a href="/impressum" target="_blank">Impressum</a>
                <a href="/terms" target="_blank">Terms</a>
                <a href="/privacy" target="_blank">Privacy</a>
                <a href="javascript:void(0);" v-b-modal.locale-modal>{{ $t(`languages.${locale.selected}`) }}</a>
            </div>
        </div>

        <b-modal centered scrollable id="locale-modal" :title="$t(`languages.${locale.selected}`)" hide-footer>
            <b-container fluid>
                <button type="button" class="btn btn-link text-capitalize btn-sm btn-block" v-for="(locale, code) in locale.available" :key="code" @click="changeLocale(code); $bvModal.hide('locale-modal')">{{ $t(`languages.${code}`, code) }}</button>
            </b-container>
        </b-modal>
    </div>
</template>

<script>

import {mapActions, mapState} from "vuex";

export default {
    name: "FloatingFooter",
    computed: {
        ...mapState({
            locale: state => state.locale
        })
    },
    methods: {
        ...mapActions('locale', ['changeLocale'])
    },
}
</script>

<style lang="scss" scoped>
.tebex-footer-wrapper {
    background: #fff;
    width: 100%;
    padding: 0 32px;
    font-size: 11px;
    font-weight: 400;
    font-family: Arial, sans-serif;
    z-index: 0;
    color: #6a6a6a !important;
    border-top: 1px solid #EFEFEF;
}

.tebex-footer-image {
    margin-right: 32px;
    width: 54px;
}

.tebex-footer-container {
    height: 40px;
}

.tebex-footer-text {
    margin-top: 2px;
}

.tebex-footer-links {
    margin-top: 2px;
    min-width: 260px;
}

.tebex-footer-links a {
    color: #6a6a6a !important;
    text-decoration: underline !important;
}

.tebex-footer-links > a:not(:last-child) {
    margin-right: 12px;
}

@media screen and (max-width: 800px) {
    .tebex-footer-wrapper {
        padding: 8px 16px;
    }

    .tebex-footer-container {
        flex-wrap: wrap;
        height: 75px;
    }

    .tebex-footer-image {
        display: none;
    }

    .tebex-footer-links {
        margin-top: 8px;
        min-width: unset;
        margin-left: unset !important;
    }
}

.tebex-footer-wrapper-dark {
    background: #2E2E2E;
    color: #B2B2B2 !important;
    border-color: #404040;


    .tebex-footer-links a {
        color: #B2B2B2 !important;
    }
}
</style>
